import { makeVar } from '@apollo/client';

import { getUserToken } from '@utils/userToken';

import {
  LoginCredentialsUserPayloadData,
  LoginSharedProjectAuthPayloadData,
} from './types';

export const authTokenVar = makeVar<LoginCredentialsUserPayloadData | null>(
  getUserToken(),
);

export const authTokenSharedVar = makeVar<
  LoginSharedProjectAuthPayloadData | null | undefined
>(undefined);
